import { useAtomValue } from 'jotai';
import { sellerAiModelsAtom } from '../atoms';

export const useSellerAiModels = () => useAtomValue(sellerAiModelsAtom);
